import { Fragment, useRef } from "react";
import { useForm } from "react-hook-form";
import Modal from "components/elements/ModalWrapper";
import CardWrapper from "components/elements/CardWrapperInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery, useQueryClient, useMutation } from "react-query";
import { addSecondaryEducation } from "queries/userQueries";

const AddSecondaryModal = ({
  setShowModal,
  showModal,
  edit,
  setEdit,
  modalData,
  setModalData,
}) => {
  const { register, handleSubmit, errors } = useForm();
  const modalRef = useRef();

  const yearArray = [];
  for (var i = 2022; i > 1979; i--) {
    yearArray.push(i);
  }
  const queryClient = useQueryClient();

  const resetValues = () => {
    setModalData();
    setEdit(false);
    setShowModal(true);
  };

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      resetValues();
    }
  };
  const mutation = useMutation(addSecondaryEducation, {
    onSuccess: () => {
      queryClient.invalidateQueries("userInfo");
      resetValues();
    },
    onError: () => {
      console.log("error");
    },
  });
  const onSubmit = async (data) => {
    try {
      await mutation.mutate({ data });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Fragment>
      <div className="modal-wrapper" ref={modalRef} onClick={closeModal}>
        <div className="modal-container flex-column justify-content-around align-items-center p-2">
          <h4>Add Secondary Education</h4>
          <div className="flex-column align-items-center justify-space-around">
            <form
              className="info-viewer justify-content-center flex-column mv-1"
              onSubmit={handleSubmit(onSubmit)}
            >
              <CardWrapper title="School">
                <div className="wrap-input">
                  <input
                    className="input"
                    id="school"
                    name="school"
                    defaultValue={modalData && modalData.school}
                    placeholder="Enter your School"
                    ref={register({
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                  />
                </div>
                {errors.school && (
                  <span className="is-danger">{errors.school.message}</span>
                )}
              </CardWrapper>
              <CardWrapper title="Board">
                <div className="wrap-input">
                  <input
                    className="input"
                    id="board"
                    name="board"
                    defaultValue={modalData && modalData.board}
                    placeholder="Enter your Board"
                    ref={register({
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                  />
                </div>
                {errors.board && (
                  <span className="is-danger">{errors.board.message}</span>
                )}
              </CardWrapper>

              <CardWrapper title="Year of Completion">
                <div className="wrap-input">
                  <select
                    className="classic input"
                    name="year"
                    id="year"
                    defaultValue={
                      edit === true ? modalData && modalData.year : null
                    }
                    ref={register({
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                  >
                    <option value="">Select Year</option>
                    {yearArray.map((year) => (
                      <option value={year} key={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
                {errors.year && (
                  <span className="is-danger">{errors.year.message}</span>
                )}
              </CardWrapper>

              <CardWrapper title="Percentage">
                <div className="wrap-input">
                  <input
                    className="input"
                    type="number"
                    id="percentage"
                    name="percentage"
                    defaultValue={modalData && modalData.percentage}
                    placeholder="0.00"
                    ref={register({
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                  />
                </div>
                {errors.percentage && (
                  <span className="is-danger">{errors.percentage.message}</span>
                )}
              </CardWrapper>

              <button className="submit-btn inline-block m-0-auto">Save</button>
            </form>
            <button
              className="cancel-btn"
              onClick={() => {
                resetValues();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddSecondaryModal;
